import { Component } from '@angular/core';
import {default as GridColumnsJSON} from "../../Shared/Component/audit-trail/audit-trail-grid-columns.json";
import { QuickviewSidebarComponent } from "../../Shared/Component/quickview-sidebar/quickview-sidebar.component";
import { default as CAT_MECO } from 'app/Shared/Constant/CAT_Event_Type_Grid_JSON/CAT_MECO.json';
import { mkConfig, generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { UserService } from 'app/Shared/Services/user.service';
import { FormsModule } from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-angular',
    imports: [QuickviewSidebarComponent, FormsModule, ButtonModule, MatTooltipModule, MultiSelectModule, MatChipsModule,
        MatFormFieldModule, MatIconModule],
    templateUrl: './angular.component.html',
    styleUrl: './angular.component.scss'
})
export class AngularComponent {
  GridColumns = GridColumnsJSON;
  LastExecutionDate: any = '';
  defaultFilterArray: any = [];
  quickviewcols: any = [];
  selectedRow: any = [];
  isQuickViewOpenClose: boolean = true;
  isOrderViewerOpenClose: boolean = false;

  selectedRowData :any= [];
  csvConfig = mkConfig({ useKeysAsHeaders: true });

  constructor(public userService:UserService) {

  }

  ngOnInit() {
    let date = new Date();
    this.LastExecutionDate = [];
      this.LastExecutionDate.push(date); // FromDate
      this.LastExecutionDate.push(date); // Todate

      this.defaultFilterArray = [
      {'isdefault': 'true', 'label': 'Date', 'columnname': 'Created_Date', 'filterby': 'IS', 'values': this.LastExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'FirmMPID', 'columnname': 'FirmMPID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'User ID', 'columnname': 'User_ID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''}
    ];

    this.quickviewcols = CAT_MECO;

    this.selectedRowData =[
      {
        "nbbPrice": "",
        "orderType": "LMT",
        "infoBarrierID": "",
        "priorFillKeyDate": "",
        "legRatioQuantity": "",
        "errorROEID": "",
        "initiator": "",
        "type": "MECO",
        "quoteID": "",
        "quoteWantedInd": "",
        "receivedQuoteID": "",
        "clientDetails": "",
        "tradingSession": "REG",
        "onlyOneQuoteFlag": "",
        "reportDate": "2024-08-28",
        "orderKeyDate": "2024-05-28 00:00:00.0",
        "price": 66,
        "firmOrderID": "",
        "fillKeyDate": "",
        "optionID": "",
        "timeInForce": "{\"DAY\":20240528}",
        "priorQuoteID": "",
        "tradeID": "",
        "quotingIDQS": "",
        "clearingFirm": "",
        "newOrderFDID": "",
        "nboPrice": "",
        "priorFulfillmentID": "",
        "routedQuoteID": "",
        "tapeTradeID": "",
        "dupROIDCond": "",
        "settlementDate": "",
        "underlying": "",
        "workingPrice": "",
        "groupName": "FLEX",
        "sellDetails": "",
        "nboQty": "",
        "custType": "",
        "buyDetails": "",
        "multiLegInd": true,
        "custDspIntrFlag": "",
        "quoteRejectedFlag": "",
        "marketCenterID": "",
        "updateDate": "2024-08-28 05:16:29.0",
        "errorCodeList": "",
        "unsolicitedInd": "",
        "mpStatusCode": "",
        "bidQty": "",
        "originatingIMID": "",
        "routedOrderID": "",
        "allocationID": "",
        "TIDType": "",
        "unpricedInd": "",
        "capacity": "",
        "atsDisplayInd": "",
        "institutionFlag": "",
        "receiverIMID": "",
        "priorOrderID": "",
        "priorUnlinked": "",
        "reservedForFutureUse": "",
        "createDate": "2024-08-28 05:16:29.0",
        "fulfillmentID": "",
        "side": "SL",
        "manualOrderID": "",
        "requestTimestamp": "",
        "leavesQty": "",
        "cancelTimestamp": "",
        "priceType": "",
        "deptType": "",
        "aggOrderKeyDate": "",
        "correspondentCRD": "",
        "askQty": "",
        "CATReporterIMID": "JONE",
        "nbboTimestamp": "",
        "senderType": "",
        "numberOfLegs": "",
        "symbol": "A",
        "senderIMID": "",
        "clientOrderID": "",
        "rsmsStatus": "N",
        "netPrice": "",
        "firmROEID": "20240528_241_288917699_meco_M",
        "firmDesignatedID": "",
        "firmDetails": "",
        "receivingDeskType": "",
        "cancelFlag": "",
        "electronicTimestamp": "",
        "manualOrderKeyDate": "",
        "aggOrderID": "",
        "priorOrderKeyDate": "",
        "buyOrderID": "",
        "manualFlag": "",
        "reportingExceptionCode": "",
        "openCloseIndicator": "",
        "destinationType": "",
        "affiliateFlag": "",
        "fileID": 11154,
        "allocationInstructionTime": "",
        "askPrice": "",
        "priorAllocationID": "",
        "lastUpdatedBy": "SYSTEM",
        "seqNum": "",
        "quoteKeyDate": "",
        "exchOriginCode": "",
        "bidPrice": "",
        "isoInd": "",
        "priorQuoteKeyDate": "",
        "electronicDupFlag": "",
        "routeRejectedFlag": "",
        "cancelQty": "",
        "DVPCustodianID": "",
        "priorRoutedOrderID": "",
        "accountHolderType": "",
        "representativeInd": "",
        "nbboSource": "",
        "session": "",
        "destination": "",
        "legRefID": "",
        "allocationKeyDate": "",
        "displayPrice": "",
        "aggregatedOrders": "",
        "RFQID": "",
        "parentOrderKeyDate": "2024-05-28 00:00:00.0",
        "eventTimestamp": "2024-05-28 10:47:09.277",
        "atsOrderType": "",
        "reservedForFutureUse4": "",
        "quantity": 66,
        "reservedForFutureUse3": "",
        "orderID": "20240529134350130-0",
        "displayQty": "",
        "tradeDate": "",
        "allocationType": "",
        "sideDetailsInd": "",
        "sellOrderID": "",
        "nbbQty": "",
        "pairedOrderID": "",
        "negotiatedTradeFlag": "",
        "actionType": "NEW",
        "solicitationFlag": "",
        "legDetails": "",
        "nextUnlinked": "",
        "parentOrderID": "20240529134351229-0",
        "fulfillmentLinkType": "",
        "counterparty": "",
        "tradeKeyDate": "",
        "reservedForFutureUse2": "",
        "reservedForFutureUse1": "",
        "occClearingMemberID": "",
        "handlingInstructions": "",
        "minQty": "",
        "priorAllocationKeyDate": ""
      }
    ];

  }

  filterEvent(){
    alert('filter');
  }

  QuickViewCloseEvent(event: any) {
    this.selectedRow = [];
    this.quickviewcols = [];
    this.isQuickViewOpenClose = false;
  }

  exportToCSV(){
   let filename = this.userService.getActiveMPID() +'_RSMS_CAT_MECO_Data_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date());
    const csv = generateCsv(this.csvConfig)(this.selectedRowData);
    const blob = asBlob(this.csvConfig)(csv);
    saveAs(blob,filename);
  }
}
